import { createFileRoute } from "@tanstack/react-router";
import { QuickBill } from "../features/bill/quick-bill";
import { Require } from "../features/require";

/** The Bill tab: the quick bill for the counter (P4-T19). F2 opens it from anywhere. */
export const Route = createFileRoute("/bill")({ component: Page });

function Page() {
	return (
		<Require permission="bill.create">
			<QuickBill />
		</Require>
	);
}
